import React from 'react'
import PropTypes from 'prop-types'
import ProductRow from './ProductRow'
import EditProduct from './EditProduct'

const PRODUCT_TYPE_LABELS = {
  sba7a: "SBA loan",
  conventional: "Term loan",
  line_of_credit: "Line of Credit",
};

export default class Product extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditable: false
    }
  }
  static propTypes = {
    loan: PropTypes.shape({
      product: PropTypes.object
    }),
    productName: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.object),
    productSwitchReasons: PropTypes.arrayOf(PropTypes.object),
    customerService: PropTypes.bool
  }
  onEditToggle = () => {
    this.setState({ isEditable: !this.state.isEditable })
  }
  get partnerProducts() {
    const { loan, partnerSettingsEnabled } = this.props
    const selectedProductString = loan?.partner?.selectedProductTypes

    if (!selectedProductString || !partnerSettingsEnabled) return null

    return JSON.parse(selectedProductString).map(pt => PRODUCT_TYPE_LABELS[pt] || pt)
  }
  render() {
    const { products, productSwitchReasons, loan, productName, customerService } = this.props
    const { isEditable } = this.state
    if (isEditable && loan) {
      const { product } = loan
      return (
        <EditProduct
          product={product}
          products={products}
          onCancel={this.onEditToggle}
          productSwitchReasons={productSwitchReasons}
          customerService={customerService}
          partnerProducts={this.partnerProducts}
        />
      )
    } else {
      return <ProductRow productName={loan ? loan.product.name : productName} onEditClick={this.onEditToggle} />
    }
  }
}
